import styled from "styled-components";
import { Link } from "react-router-dom";

export default function Unauthorized() {
  return (
    <Container>
      <Card>
        <Icon>⛔</Icon>
        <Title>Access Denied</Title>
        <Text>You do not have permission to view this page.</Text>
        <Link to="/">Return to Home</Link>
      </Card>
    </Container>
  );
}

const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #1a1a1a, #2c2c2c);
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
  padding: 3rem;
  border-radius: 20px;
  text-align: center;
  color: white;
  max-width: 400px;
`;

const Icon = styled.div`
  font-size: 3.5rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-top: 1rem;
`;

const Text = styled.p`
  color: #aaa;
  margin: 1rem 0 1.5rem;
`;